import React, { useRef } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';

const PreviewSlider = ({ images = [] }) => {
    const sliderRef = useRef();
    const settings = {
        autoplay: true,
        arrows: false,
        dots: false,
    };
    const sliderNext = () => {
        sliderRef.current.slickNext();
    };
    const sliderPrev = () => {
        sliderRef.current.slickPrev();
    };

    return (
        <div className="appie-video-player-slider" style={{ position: 'relative' }}>
            <span onClick={sliderPrev} className="prev slick-arrow" style={{ display: 'block' }}>
                <i className="fal fa-arrow-left" />
            </span>
            <Slider ref={sliderRef} {...settings}>
                {images.map((image) => (
                    <div key={image?.url} className="item">
                        <img width="100%" src={image?.url} alt={image?.alt} />
                    </div>
                ))}
            </Slider>
            <span onClick={sliderNext} className="next slick-arrow" style={{ display: 'block' }}>
                <i className="fal fa-arrow-right" />
            </span>
        </div>
    );
};

export default PreviewSlider;
